module.exports = __webpack_public_path__ + "img/brightness.c2bdae0d.svg";